(function () {
  if (window.__skioPdpButtonInstalled) return;
  window.__skioPdpButtonInstalled = true;

  var matchIndex = null; // array of { title, handle, variantId }

  function extractProductPlatformId() {
    var params = new URLSearchParams(window.location.search);
    return params.get('product');
  }

  function numericIdFromGid(gid) {
    if (!gid) return null;
    var parts = gid.split('/');
    return parts[parts.length - 1];
  }

  function loadDynamicBoxData() {
    var productPlatformId = extractProductPlatformId();
    if (!productPlatformId) return Promise.resolve(null);
    return fetch('https://api.skio.com/storefront-http/get-dynamic-box', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ productPlatformId: productPlatformId, shopDomain: window.location.hostname })
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (!data || !data.ok || !data.DynamicBox) return null;
        var index = [];
        data.DynamicBox.selectableProductVariants.forEach(function (product) {
          (product.productVariants || []).forEach(function (variant) {
            index.push({
              title: variant.productVariantTitle,
              handle: product.productHandle,
              variantId: numericIdFromGid(variant.platformId)
            });
          });
        });
        matchIndex = index;
        return index;
      })
      .catch(function () { return null; });
  }

  function findMatch(cardTitle) {
    if (!matchIndex) return null;
    for (var i = 0; i < matchIndex.length; i++) {
      if (matchIndex[i].title && cardTitle.indexOf(matchIndex[i].title) !== -1) {
        return matchIndex[i];
      }
    }
    return null;
  }

  function makeButton(handle, variantId, label) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.textContent = label || 'LEARN MORE';
    btn.className = 'skio-pdp-learn-more-btn';
    btn.style.cssText = 'display:block;margin:8px auto 0;padding:6px 16px;background:#0b61cd;color:#fff;border:none;border-radius:999px;font-size:12px;font-weight:600;letter-spacing:0.02em;cursor:pointer;text-transform:uppercase;font-family:inherit;';
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var url = '/products/' + handle + (variantId ? ('?variant=' + variantId) : '');
      window.open(url, '_blank', 'noopener');
    });
    return btn;
  }

  // One "LEARN MORE" button per product category section (placed right
  // under the category heading, e.g. "Protein + Focus"), rather than one
  // per product card. Each category section groups variants of a single
  // underlying Shopify product, so the first card's matched handle
  // represents the whole section - links to the base product page
  // (no ?variant=) since the button now represents the category, not
  // one specific flavor.
  function insertCategoryButtons() {
    var root = document.getElementById('skio-root');
    if (!root || !matchIndex) return;
    var headings = root.querySelectorAll('h2');
    headings.forEach(function (h2) {
      if (h2.getAttribute('data-skio-cat-btn') === 'true') return;
      var section = h2.parentElement;
      if (!section) return;
      var firstTitleWrap = section.querySelector('[title]');
      if (!firstTitleWrap) return;
      var cardTitle = firstTitleWrap.getAttribute('title');
      var match = findMatch(cardTitle);
      if (!match) return;
      var btn = makeButton(match.handle, null, 'LEARN MORE');
      h2.insertAdjacentElement('afterend', btn);
      h2.setAttribute('data-skio-cat-btn', 'true');
    });
  }

  function findLeafByText(text) {
    var root = document.getElementById('skio-root');
    if (!root) return null;
    var all = root.querySelectorAll('div');
    for (var i = 0; i < all.length; i++) {
      if (all[i].children.length === 0 && all[i].textContent.trim() === text) {
        return all[i];
      }
    }
    return null;
  }

  function makeHeading(text) {
    var h = document.createElement('div');
    h.textContent = text;
    h.style.cssText = 'font-weight:700;font-size:14px;color:#0b61cd;text-align:center;margin-bottom:12px;text-transform:uppercase;letter-spacing:0.02em;';
    return h;
  }

  function insertHeadings() {
    var root = document.getElementById('skio-root');
    if (!root) return;

    if (!document.getElementById('skio-freq-heading')) {
      var weeklyDiv = findLeafByText('Weekly');
      var freqBtn = weeklyDiv ? weeklyDiv.closest('button') : null;
      var freqContainer = freqBtn ? freqBtn.parentElement : null;
      if (freqContainer && freqContainer.parentElement) {
        var h1 = makeHeading('Pick Your Delivery Intervals');
        h1.id = 'skio-freq-heading';
        freqContainer.parentElement.insertBefore(h1, freqContainer);
      }
    }

    if (!document.getElementById('skio-qty-heading')) {
      var tierBtn = null;
      var buttons = root.querySelectorAll('button');
      for (var i = 0; i < buttons.length; i++) {
        if (buttons[i].querySelector('div[style*="font-size: 12px"]')) {
          tierBtn = buttons[i];
          break;
        }
      }
      var tierContainer = tierBtn ? tierBtn.parentElement : null;
      if (tierContainer && tierContainer.parentElement) {
        var h2 = makeHeading('Pick Your Quantity');
        h2.id = 'skio-qty-heading';
        tierContainer.parentElement.insertBefore(h2, tierContainer);
      }
    }
  }

  function tick() {
    insertCategoryButtons();
    insertHeadings();
  }

  function start() {
    var observer = new MutationObserver(function () {
      tick();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    tick();
    setInterval(tick, 1500);
    loadDynamicBoxData().then(function () {
      tick();
    });
  }

  // This script is loaded synchronously in <head>, before <body> exists yet,
  // so document.body would be null here - wait for it before touching the DOM.
  if (document.body) {
    start();
  } else {
    document.addEventListener('DOMContentLoaded', start);
  }
})();
